import { StandardOutputModel } from "./StandardOutputModel"

//All fields should be mapped in GetCurrentUserDetails API Response(Decryption process will be there)
 export class UserDetailsViewModel extends StandardOutputModel {
   public memberId : number | undefined
   public memberName : string| undefined
   public memberShortName : string| undefined
   public companyCode? : number
   public reportingTo? : number
   public reportingToName? : string
   public staffPSNo? : string
   public eccWebLogin? : string
   public designation? : string
   public eMailId? : string
   public mobileNo?: string
   public isInternal? : boolean
   public eipUserId? : number
   public isActive? : boolean
   public groupId? : number
   public jwtToken? : string
   public loginAuditNumber? : string
   public isDuplicateLogin? : boolean
 }